export const JT_BASE_URL = "https://hr-payroll-assets.preview.emergentagent.com";

export const PREVIEW_STATUS = {
  NEW: { label: "Nuovo", cls: "bg-sky-100 text-sky-800 border-sky-300" },
  CHANGED: { label: "Modificato", cls: "bg-amber-100 text-amber-800 border-amber-300" },
  UNCHANGED: { label: "Invariato", cls: "bg-slate-100 text-slate-600 border-slate-300" },
  CONFLICT: { label: "Conflitto", cls: "bg-red-100 text-red-800 border-red-300" },
};
export const AVAILABILITY_LABELS = { UNKNOWN: "Da verificare", AVAILABLE: "Disponibile", NOT_AVAILABLE: "Non disponibile", PARTIAL: "Parziale" };
export const AVAILABILITY_CLS = {
  UNKNOWN: "bg-slate-100 text-slate-600", AVAILABLE: "bg-green-100 text-green-800 border-green-300",
  NOT_AVAILABLE: "bg-red-100 text-red-700 border-red-300", PARTIAL: "bg-amber-100 text-amber-800 border-amber-300",
};
export const CONN_STATUS_LABELS = {
  NOT_CONNECTED: "NON COLLEGATO", CONFIGURING: "IN CONFIGURAZIONE", CONNECTED: "CONNESSO",
  DEGRADED: "DEGRADATO", AUTH_ERROR: "ERRORE AUTH", API_ERROR: "ERRORE API", DISABLED: "DISABILITATO",
};
export const TRANSFORMATIONS = ["DIRECT", "ENUM_MAP", "DATE_TRANSFORM", "BOOLEAN_MAP", "AGGREGATION", "SUM", "COUNT", "AVERAGE", "FTE_CALCULATION", "FILTER", "GROUP_BY", "CUSTOM_SAFE_TRANSFORM"];

export const fmtV = (v) => (v === null || v === undefined ? "—" : v);
export const fmtDate = (d) => (d ? new Date(d).toLocaleString("it-IT") : "—");
